import { useLocation } from 'react-router-dom';
import qs from 'query-string';

export const useTechnographicsFilters = () => {
	const location = useLocation();

	const params = qs.parse(location.search, {
		arrayFormat: 'bracket-separator',
		arrayFormatSeparator: ','
	});

	return {
		...params,
		page: Number(params.page) || 0,
		technographics_page: Number(params.technographics_page) || 0,
		size: Number(params.size)
	};
};
